import { model } from "../firebase/firebase"

export async function generateLabelTemplate(
	prompt: string,
	currentTemplate: string,
	availableVariables: string[] = []
): Promise<string> {
	const variablesSection =
		availableVariables.length > 0
			? `Available template variables (ONLY these may be used, in the format {{variableName}}):
${availableVariables.map((v) => `- {{${v}}}`).join("\n")}

Do NOT introduce any variables that are not in the list above.`
			: ""

	const fullPrompt = `You are an expert assistant for generating HTML delivery label templates.

The user wants to make the following change to the existing HTML template:
"${prompt}"

Current HTML template:
\`\`\`html
${currentTemplate}
\`\`\`

${variablesSection}

Return ONLY the updated HTML, with no explanations, no markdown, no code blocks. Just the raw HTML.`

	const result = await model.generateContent(fullPrompt)
	const text = result.response.text().trim()
	return text
		.replace(/^```[\w]*\n?/, "")
		.replace(/\n?```$/, "")
		.trim()
}
